module.exports = __webpack_public_path__ + "img/h5img6.cf2ac0ea.png";